// Bible Data Loader (Optimized for Lazy Loading)
// Loads individual book JSON files on demand

/**
 * Bible data cache
 */
const BIBLE_CACHE = {
    books: {}, // Cache loaded books
};

// Standard Bible Book Metadata (Name, Key, Chapters)
const BIBLE_BOOKS_METADATA = [
    // Old Testament
    { name: 'Genèse', key: 'Genesisy', chapters: 50 },
    { name: 'Exode', key: 'Eksodosy', chapters: 40 },
    { name: 'Lévitique', key: 'Levitikosy', chapters: 27 },
    { name: 'Nombres', key: 'Nomery', chapters: 36 },
    { name: 'Deutéronome', key: 'Deotoronomia', chapters: 34 },
    { name: 'Josué', key: 'Josoa', chapters: 24 },
    { name: 'Juges', key: 'Mpitsara', chapters: 21 },
    { name: 'Ruth', key: 'Rota', chapters: 4 },
    { name: '1 Samuel', key: 'I Samoela', chapters: 31 },
    { name: '2 Samuel', key: 'II Samoela', chapters: 24 },
    { name: '1 Rois', key: 'I Mpanjaka', chapters: 22 },
    { name: '2 Rois', key: 'II Mpanjaka', chapters: 25 },
    { name: '1 Chroniques', key: 'I Tantara', chapters: 29 },
    { name: '2 Chroniques', key: 'II Tantara', chapters: 36 },
    { name: 'Esdras', key: 'Ezra', chapters: 10 },
    { name: 'Néhémie', key: 'Nehemia', chapters: 13 },
    { name: 'Esther', key: 'Estera', chapters: 10 },
    { name: 'Job', key: 'Joba', chapters: 42 },
    { name: 'Psaumes', key: 'Psaumes', chapters: 150 }, // Key changed to match French file name for simplicity if needed
    { name: 'Proverbes', key: 'Ohabolana', chapters: 31 },
    { name: 'Ecclésiaste', key: 'Mpitoriteny', chapters: 12 },
    { name: 'Cantique des Cantiques', key: 'Tonon-kiran\'i Solomona', chapters: 8 },
    { name: 'Ésaïe', key: 'Isaia', chapters: 66 },
    { name: 'Jérémie', key: 'Jeremia', chapters: 52 },
    { name: 'Lamentations', key: 'Fitomaniana', chapters: 5 },
    { name: 'Ézéchiel', key: 'Ezekiela', chapters: 48 },
    { name: 'Daniel', key: 'Daniela', chapters: 12 },
    { name: 'Osée', key: 'Hosea', chapters: 14 },
    { name: 'Joël', key: 'Joela', chapters: 3 },
    { name: 'Amos', key: 'Amosa', chapters: 9 },
    { name: 'Abdias', key: 'Obadia', chapters: 1 },
    { name: 'Jonas', key: 'Jona', chapters: 4 },
    { name: 'Michée', key: 'Mika', chapters: 7 },
    { name: 'Nahum', key: 'Nahoma', chapters: 3 },
    { name: 'Habacuc', key: 'Habakoka', chapters: 3 },
    { name: 'Sophonie', key: 'Zefania', chapters: 3 },
    { name: 'Aggée', key: 'Hagay', chapters: 2 },
    { name: 'Zacharie', key: 'Zakaria', chapters: 14 },
    { name: 'Malachie', key: 'Malakia', chapters: 4 },

    // New Testament
    { name: 'Matthieu', key: 'Matio', chapters: 28 },
    { name: 'Marc', key: 'Marka', chapters: 16 },
    { name: 'Luc', key: 'Lioka', chapters: 24 },
    { name: 'Jean', key: 'Jaona', chapters: 21 },
    { name: 'Actes', key: 'Asan\'ny Apostoly', chapters: 28 },
    { name: 'Romains', key: 'Romana', chapters: 16 },
    { name: '1 Corinthiens', key: 'I Korintiana', chapters: 16 },
    { name: '2 Corinthiens', key: 'II Korintiana', chapters: 13 },
    { name: 'Galates', key: 'Galatiana', chapters: 6 },
    { name: 'Éphésiens', key: 'Efesiana', chapters: 6 },
    { name: 'Philippiens', key: 'Filipiana', chapters: 4 },
    { name: 'Colossiens', key: 'Kolosiana', chapters: 4 },
    { name: '1 Thessaloniciens', key: 'I Tesaloniana', chapters: 5 },
    { name: '2 Thessaloniciens', key: 'II Tesaloniana', chapters: 3 },
    { name: '1 Timothée', key: 'I Timoty', chapters: 6 },
    { name: '2 Timothée', key: 'II Timoty', chapters: 4 },
    { name: 'Tite', key: 'Titosy', chapters: 3 },
    { name: 'Philémon', key: 'Filemona', chapters: 1 },
    { name: 'Hébreux', key: 'Hebreo', chapters: 13 },
    { name: 'Jacques', key: 'Jakoba', chapters: 5 },
    { name: '1 Pierre', key: 'I Petera', chapters: 5 },
    { name: '2 Pierre', key: 'II Petera', chapters: 3 },
    { name: '1 Jean', key: 'I Jaona', chapters: 5 },
    { name: '2 Jean', key: 'II Jaona', chapters: 1 },
    { name: '3 Jean', key: 'III Jaona', chapters: 1 },
    { name: 'Jude', key: 'Joda', chapters: 1 },
    { name: 'Apocalypse', key: 'Apokalipsy', chapters: 22 },
];

// Map French book names to English names for single-file English bibles
const FRENCH_TO_ENGLISH = {
    'Genèse': 'Genesis', 'Exode': 'Exodus', 'Lévitique': 'Leviticus', 'Nombres': 'Numbers', 'Deutéronome': 'Deuteronomy',
    'Josué': 'Joshua', 'Juges': 'Judges', 'Ruth': 'Ruth', '1 Samuel': '1 Samuel', '2 Samuel': '2 Samuel',
    '1 Rois': '1 Kings', '2 Rois': '2 Kings', '1 Chroniques': '1 Chronicles', '2 Chroniques': '2 Chronicles',
    'Esdras': 'Ezra', 'Néhémie': 'Nehemiah', 'Esther': 'Esther', 'Job': 'Job', 'Psaumes': 'Psalms',
    'Proverbes': 'Proverbs', 'Ecclésiaste': 'Ecclesiastes', 'Cantique des Cantiques': "Song of Solomon", 'Ésaïe': 'Isaiah', 'Jérémie': 'Jeremiah',
    'Lamentations': 'Lamentations', 'Ézéchiel': 'Ezekiel', 'Daniel': 'Daniel', 'Osée': 'Hosea', 'Joël': 'Joel',
    'Amos': 'Amos', 'Abdias': 'Obadiah', 'Jonas': 'Jonah', 'Michée': 'Micah', 'Nahum': 'Nahum',
    'Habacuc': 'Habakkuk', 'Sophonie': 'Zephaniah', 'Aggée': 'Haggai', 'Zacharie': 'Zechariah', 'Malachie': 'Malachi',
    'Matthieu': 'Matthew', 'Marc': 'Mark', 'Luc': 'Luke', 'Jean': 'John', 'Actes': 'Acts',
    'Romains': 'Romans', '1 Corinthiens': '1 Corinthians', '2 Corinthiens': '2 Corinthians', 'Galates': 'Galatians', 'Éphésiens': 'Ephesians',
    'Philippiens': 'Philippians', 'Colossiens': 'Colossians', '1 Thessaloniciens': '1 Thessalonians', '2 Thessaloniciens': '2 Thessalonians',
    '1 Timothée': '1 Timothy', '2 Timothée': '2 Timothy', 'Tite': 'Titus', 'Philémon': 'Philemon', 'Hébreux': 'Hebrews',
    'Jacques': 'James', '1 Pierre': '1 Peter', '2 Pierre': '2 Peter', '1 Jean': '1 John', '2 Jean': '2 John', '3 Jean': '3 John',
    'Jude': 'Jude', 'Apocalypse': 'Revelation'
};

/**
 * Load a specific book JSON
 */
export async function loadBook(bookName, version = 'french') {
    // We expect the French book name as input (e.g. "Genèse")
    // because our JSON files are named by French book name.

    // Normalize logic for mapping if needed, 
    // but current JSONs are generated with French names.

    const cacheKey = `${version}::${bookName}`;
    if (BIBLE_CACHE.books[cacheKey]) {
        return BIBLE_CACHE.books[cacheKey];
    }

    try {
        const fileName = encodeURIComponent(bookName) + '.json';
        const folder = `${version}-bible`;
        console.log(`Fetching book: ${fileName} from ${folder}`);
        const response = await fetch(`/data/${folder}/books/${fileName}`);

        if (!response.ok) {
            throw new Error(`Book not found: ${bookName}`);
        }

        const contentType = (response.headers.get('content-type') || '').toLowerCase();
        if (!contentType.includes('application/json')) {
            console.warn(`Book ${bookName} for version '${version}' is not JSON (content-type: ${contentType}).`);

            // Special-case: some languages are shipped as a single text file (e.g. Malagasy)
            // Try to load and parse a single-file bible (bible-mg.txt) when version === 'malagasy'
            if (version === 'malagasy') {
                try {
                    const singleFileResp = await fetch(`/data/malagasy-bible/bible-mg.txt`);
                    if (singleFileResp.ok) {
                        const txt = await singleFileResp.text();

                        // Parse single-file format to extract requested book
                        const optimizedData = parseSingleFileBible(txt, bookName, version);
                        if (optimizedData) {
                            BIBLE_CACHE.books[cacheKey] = optimizedData;
                            console.log(`✅ Book ${bookName} loaded from single-file Malagasy bible`);
                            return optimizedData;
                        }
                    }
                } catch (err) {
                    console.warn('Failed to parse single-file Malagasy bible:', err);
                }
            }

            console.warn(`Falling back to 'french' version for ${bookName}.`);
            if (version !== 'french') {
                return loadBook(bookName, 'french');
            }
            throw new Error(`Book ${bookName} is not available as JSON for version '${version}'.`);
        }

        const bookData = await response.json();

        // Optimize structure for quick access: { chapterNum: { verseNum: "text" } }
        // The JSON comes as { chapters: [ { chapter: 1, verses: [ { verse: 1, text: "" } ] } ] }
        const optimizedData = {};

        if (bookData.chapters) {
            bookData.chapters.forEach(chap => {
                optimizedData[chap.chapter] = {};
                if (chap.verses) {
                    chap.verses.forEach(v => {
                        optimizedData[chap.chapter][v.verse] = v.text;
                    });
                }
            });
        }

        // Cache per-version per-book
        BIBLE_CACHE.books[cacheKey] = optimizedData;
        console.log(`✅ Book ${bookName} loaded`);
        return optimizedData;
    } catch (error) {
        console.error(`Error loading book ${bookName}:`, error);
        throw error;
    }
}

/**
 * Parse a single-file bible text and extract a book's chapters/verses.
 * This is a lightweight parser tailored to the project's `bible-mg.txt` layout.
 */
function parseSingleFileBible(text, frenchBookName, version = 'malagasy') {
    // Map french name -> metadata key (malagasy short name) to find header
    const meta = BIBLE_BOOKS_METADATA.find(b => b.name === frenchBookName);
    const fileKey = meta ? meta.key : null;

    const lines = text.split('\n');

    // Build sections keyed by header e.g. 'Amosa.txt' (header lines end with .txt)
    const sections = {};
    let currentHeader = null;
    for (let rawLine of lines) {
        const line = rawLine.trim();
        if (!line) continue;

        // Header like "Amosa.txt" or "Apokalipsy.txt"
        if (/^[\wÀ-ÿ\s'’-]+\.txt$/i.test(line)) {
            currentHeader = line.replace(/\.txt$/i, '').trim();
            sections[currentHeader] = sections[currentHeader] || [];
            continue;
        }

        if (currentHeader) {
            sections[currentHeader].push(line);
        }
    }

    // If English single-file format (tab-separated "Book Chapter:Verse<TAB>text"), parse differently
    if (version === 'english') {
        const englishName = (FRENCH_TO_ENGLISH[frenchBookName] || frenchBookName).toLowerCase();
        const optimized = {};

        const lines = text.split('\n');
        for (const raw of lines) {
            if (!raw) continue;
            // Expect format: "Book Chapter:Verse\tText"
            const parts = raw.split('\t');
            if (parts.length < 2) continue;
            const ref = parts[0].trim();
            const verseText = parts[1].trim();

            const refMatch = ref.match(/^(.+)\s+(\d+):(\d+)$/);
            if (!refMatch) continue;
            const bookEnglish = refMatch[1].trim().toLowerCase();
            const chap = parseInt(refMatch[2], 10);
            const verse = parseInt(refMatch[3], 10);

            if (bookEnglish !== englishName) continue;

            if (!optimized[chap]) optimized[chap] = {};
            optimized[chap][verse] = verseText;
        }

        return Object.keys(optimized).length ? optimized : null;
    }

    // Default: malagasy-style single-file with headers like "Amosa.txt"
    // Candidate header names to try
    const candidates = [];
    if (fileKey) candidates.push(fileKey);
    candidates.push(frenchBookName);

    // Find a section that matches one of the candidates (case-insensitive)
    let matched = null;
    for (const key of Object.keys(sections)) {
        for (const cand of candidates) {
            if (!cand) continue;
            if (key.toLowerCase() === cand.toLowerCase()) {
                matched = key;
                break;
            }
        }
        if (matched) break;
    }

    if (!matched) return null;

    const bookLines = sections[matched];
    const optimized = {};

    // Parse lines containing ending like "(Book X:Y)" or "(X:Y)"
    for (const ln of bookLines) {
        // Try to extract verse by trailing '(... X:Y)'
        const m = ln.match(/^(?:[«”\s]*)([\s\S]*?)\s*\((?:[^)]*?)\s?(\d+):(\d+)\)\s*$/);
        if (m) {
            const textPart = m[1].replace(/^«|»$/g, '').trim();
            const chap = parseInt(m[2], 10);
            const verse = parseInt(m[3], 10);

            if (!optimized[chap]) optimized[chap] = {};
            optimized[chap][verse] = textPart;
        }
    }

    return Object.keys(optimized).length ? optimized : null;
}

/**
 * Get list of all books
 */
export async function getBooksList(language = 'french') {
    // Return static metadata (instant!)
    return BIBLE_BOOKS_METADATA.map(b => ({
        name: language === 'malagasy' ? b.key : b.name,
        key: b.name,  // Keep French name as canonical key for file names where applicable
        chapters: b.chapters
    }));
}

/**
 * Get verse text
 */
export async function getVerse(versionId, bookName, chapter, verse) {
    try {
        // Assume versionId is 'french' for now
        const bookData = await loadBook(bookName, versionId);

        const chapterNum = parseInt(chapter);
        const verseNum = parseInt(verse);

        if (bookData[chapterNum] && bookData[chapterNum][verseNum]) {
            return bookData[chapterNum][verseNum];
        }

        throw new Error(`Verse '${bookName} ${chapter}:${verse}' not found`);
    } catch (error) {
        console.error(`Error getting verse:`, error);
        throw error;
    }
}

/**
 * Get range of verses
 */
export async function getVerses(versionId, bookName, chapter, verseStart, verseEnd) {
    try {
        const bookData = await loadBook(bookName, versionId);

        const chapterNum = parseInt(chapter);
        const start = parseInt(verseStart);
        const end = parseInt(verseEnd);

        const verses = [];

        if (bookData[chapterNum]) {
            const dayChapter = bookData[chapterNum];

            for (let i = start; i <= end; i++) {
                if (dayChapter[i]) {
                    verses.push({
                        verse: i,
                        text: dayChapter[i]
                    });
                }
            }
        }

        if (verses.length === 0) {
            throw new Error(`Verses range ${start}-${end} not found in ${bookName} ${chapter}`);
        }

        return verses;
    } catch (error) {
        console.error(`Error getting verses range:`, error);
        throw error;
    }
}

/**
 * Parse verse reference
 */
export function parseVerseReference(text) {
    const patterns = [
        /^([A-Za-zÀ-ÿ\s\d]+)\s+(\d+):(\d+)(?:-(\d+))?$/,
        /^([A-Za-zÀ-ÿ\s\d]+)\s+(\d+)$/
    ];

    for (const pattern of patterns) {
        const match = text.trim().match(pattern);
        if (match) {
            return {
                book: match[1].trim(),
                chapter: parseInt(match[2]),
                verseStart: match[3] ? parseInt(match[3]) : null,
                verseEnd: match[4] ? parseInt(match[4]) : (match[3] ? parseInt(match[3]) : null),
            };
        }
    }
    return null;
}
